import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'regionLevel5Switch'
    ])
  },
}



// WEBPACK FOOTER //
// ./src/mixins/role.js